<template>
  <TipTap
    :content.sync="content"
    :style-settings="{fontSize: 100}"
    :editor-height="editorHeight"
    hide-toolbar
    mention-extension
    :extension-options="extensionOptions"
  />
</template>

<script lang="ts">
import { ExtensionOptions } from '@orbica/vue-modules'
import Component from 'vue-class-component'

import TipTap from '@/components/TipTap/TipTap.vue'
import TTMixin from '@/components/TipTap/wrappers/TTMixin'

const components = {
  TipTap,
}

@Component({ components })
export default class TTField extends TTMixin {
  showParent = false

  get defaultStoryPathToEdit () {
    return this.$typedStore.public.display.defaultStoryPathToEdit
  }

  get extensionOptions (): ExtensionOptions {
    return {
      bold: false,
      bulletList: false,
      codeBlock: false,
      dropcursor: false,
      gapcursor: false,
      heading: false,
      horizontalRule: false,
      image: false,
      italic: false,
      link: false,
      listItem: false,
      orderedList: false,
      strike: false,
      table: false,
      tableCell: false,
      tableHeader: false,
      tableRow: false,
      textAlign: false,
      typography: false,
      underline: false,
    }
  }
}
</script>
